import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';

export interface IAccordionProps extends AccordionProps {}

const Accordion = (props: IAccordionProps): JSX.Element => {
  return <MuiAccordion {...props} />;
};

export default Accordion;
